function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_complete"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 382.398,
    style: {
      fill: "#E6E6E6"
    },
    width: 500,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.704,
    y: 397.528,
    style: {
      fill: "#E6E6E6"
    },
    width: 33.122,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.029,
    y: 397.528,
    style: {
      fill: "#E6E6E6"
    },
    width: 19.193,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.362,
    y: 401.208,
    style: {
      fill: "#E6E6E6"
    },
    width: 19.192,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.423,
    y: 406.791,
    style: {
      fill: "#E6E6E6"
    },
    width: 43.193,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.187,
    y: 406.791,
    style: {
      fill: "#E6E6E6"
    },
    width: 6.333,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.667,
    y: 401.208,
    style: {
      fill: "#E6E6E6"
    },
    width: 93.676,
    height: 0.25
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M237.014,337.8H43.915c-3.147,0-5.708-2.561-5.708-5.708V60.66c0-3.147,2.561-5.708,5.708-5.708 h193.099c3.146,0,5.707,2.561,5.707,5.708v271.432C242.721,335.239,240.16,337.8,237.014,337.8z M43.915,55.203 c-3.01,0-5.458,2.448-5.458,5.458v271.432c0,3.01,2.448,5.458,5.458,5.458h193.099c3.009,0,5.457-2.448,5.457-5.458V60.66 c0-3.009-2.448-5.458-5.457-5.458H43.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M453.31,337.8H260.212c-3.146,0-5.707-2.561-5.707-5.708V60.66c0-3.147,2.561-5.708,5.707-5.708 H453.31c3.148,0,5.708,2.561,5.708,5.708v271.432C459.019,335.239,456.458,337.8,453.31,337.8z M260.212,55.203 c-3.009,0-5.457,2.448-5.457,5.458v271.432c0,3.01,2.448,5.458,5.457,5.458H453.31c3.01,0,5.458-2.448,5.458-5.458V60.66 c0-3.009-2.448-5.458-5.458-5.458H260.212z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 245.41,
    y: 296.977,
    style: {
      fill: "#E0E0E0"
    },
    width: 21.989,
    height: 87.234
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAFAFA"
    },
    points: "263.223,384.212 267.399,384.212 267.399,372.332 258.844,372.332  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.055,
    y: 296.977,
    style: {
      fill: "#E0E0E0"
    },
    width: 21.989,
    height: 87.234
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.399,
    y: 296.977,
    style: {
      fill: "#FAFAFA"
    },
    width: 100.001,
    height: 79.945
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M263.773,300.907v21.151h-92.748v-21.151H263.773 M264.159,300.521h-93.521v21.924h93.521V300.521 L264.159,300.521z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAFAFA"
    },
    points: "171.575,384.212 167.399,384.212 167.399,372.332 175.954,372.332  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M215.187,311.482c0,1.221,0.99,2.212,2.212,2.212c1.221,0,2.212-0.99,2.212-2.212 c0-1.221-0.99-2.212-2.212-2.212C216.178,309.271,215.187,310.261,215.187,311.482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M263.773,326.374v21.151h-92.748v-21.151H263.773 M264.159,325.988h-93.521v21.924h93.521V325.988 L264.159,325.988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M215.187,336.949c0,1.221,0.99,2.212,2.212,2.212c1.221,0,2.212-0.99,2.212-2.212 s-0.99-2.212-2.212-2.212C216.178,334.738,215.187,335.728,215.187,336.949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M263.773,351.841v21.151h-92.748v-21.151H263.773 M264.159,351.455h-93.521v21.924h93.521V351.455 L264.159,351.455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M215.187,362.417c0,1.221,0.99,2.212,2.212,2.212c1.221,0,2.212-0.99,2.212-2.212 s-0.99-2.212-2.212-2.212C216.178,360.205,215.187,361.195,215.187,362.417z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 135.621,
    y: 246.316,
    style: {
      fill: "#E0E0E0"
    },
    width: 21.989,
    height: 137.896
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAFAFA"
    },
    points: "153.434,384.212 157.61,384.212 157.61,372.332 149.055,372.332  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.438,
    y: 246.316,
    style: {
      fill: "#E0E0E0"
    },
    width: 21.989,
    height: 137.896
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.783,
    y: 246.316,
    style: {
      fill: "#FAFAFA"
    },
    width: 85.827,
    height: 130.606
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M153.915,250.014v29.57H75.478v-29.57H153.915 M154.37,249.559H75.023v30.481h79.347V249.559 L154.37,249.559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M153.915,283.178v78.436h-37.361v-78.436H153.915 M154.37,282.723h-38.272v79.348h38.272V282.723 L154.37,282.723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M112.839,283.178v78.436H75.478v-78.436H112.839 M113.295,282.723H75.023v79.348h38.272V282.723 L113.295,282.723z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAFAFA"
    },
    points: "75.959,384.212 71.783,384.212 71.783,372.332 80.338,372.332  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M112.485,264.799c0,1.222,0.99,2.212,2.212,2.212c1.221,0,2.212-0.99,2.212-2.212 c0-1.221-0.99-2.212-2.212-2.212C113.475,262.588,112.485,263.578,112.485,264.799z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M120.403,320.526c0,1.221,0.99,2.212,2.212,2.212c1.222,0,2.212-0.99,2.212-2.212 c0-1.221-0.99-2.212-2.212-2.212C121.393,318.314,120.403,319.304,120.403,320.526z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M104.566,320.526c0,1.221,0.99,2.212,2.212,2.212c1.221,0,2.212-0.99,2.212-2.212 c0-1.221-0.99-2.212-2.212-2.212C105.557,318.314,104.566,319.304,104.566,320.526z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M102.075,207.869h-9.276c0,0,1.61,8.575,1.61,13.621c0,5.046-7.056,24.826,3.028,24.826 c10.083,0,3.028-19.781,3.028-24.826C100.464,216.443,102.075,207.869,102.075,207.869z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M66.803,228.148v6.027c0,6.677,5.463,12.14,12.141,12.14h6.027c6.677,0,12.14-5.463,12.14-12.14 v-6.027H66.803z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M195.667,284.265c0,6.992,7.831,12.713,17.402,12.713h8.639c9.572,0,17.403-5.721,17.403-12.713 H195.667z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M424.606,274.03c-5.24,4.277-12.472,12.109-19.099,23.128c-4.414,7.338-7.074,15.027-8.242,25.185 c0.025-11.499,0.061-23.854,0.101-35.514c1.331-3.001,4.371-9.916,6.552-15.38c7.277-18.231,9.987-22.714,16.532-38.439 c8.729-20.974,17.674-45.861,15.113-43.872c-5.219,4.052-25.22,41.504-27.382,46.865c-7.436,18.44-9.507,31.881-10.794,44.852 c0.04-10.952,0.083-21.008,0.125-28.767c0.134-25.308,0.565-33.476,0.775-35.995c0.809-1.28,1.765-2.772,2.321-3.576 c4.698-6.793,6.51-12.58,10.937-22.712c6.273-14.357,11.675-39.847,10.096-38.561c-6.576,5.353-11.763,16.862-18.579,31.527 c-6.815,14.665-4.867,23.098-6.219,35.623c-0.284,2.458-0.501,11.733-0.658,24.588c-1.768-13.695-5.084-22.72-11.134-30.921 c-7.442-10.087-14.641-16.901-19.923-20.46c-5.282-3.558,9.121,21.22,16.009,32.035c6.134,9.631,11.784,18.13,14.97,26.5 c-0.169,17.422-0.247,39.484-0.247,60.02c-1.58-9.346-4.16-19.409-7.602-27.202c-4.136-9.363-10.499-23.724-15.564-28.595 c-1.217-1.17,5.296,26.76,9.475,34.187c4.18,7.427,7.248,14.426,9.879,18.636c0.614,0.982,2.65,4.77,3.813,6.948 c0.011,25.07,0.139,47.192,0.357,54.722h1.083c-0.074-1.943-0.086-14.696-0.063-31.575c2.608-9.165,8.573-19.623,13.495-29.164 C416.106,297.697,429.847,269.752,424.606,274.03z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "412.44,384.212 381.097,384.212 378.731,353.488 414.806,353.488  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "417.142,357.068 376.395,357.068 375.228,346.702 418.309,346.702  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 68.208,
    y: 75.497,
    style: {
      fill: "#E0E0E0"
    },
    width: 56.052,
    height: 61.549
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.433,
    y: 75.497,
    style: {
      fill: "#F5F5F5"
    },
    width: 57.898,
    height: 61.549
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.457,
    y: 82.174,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 207.6537 4.8903)",
    style: {
      fill: "#FFFFFF"
    },
    width: 51.848,
    height: 48.197
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.025,
    y: 93.856,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 207.6537 4.8903)",
    style: {
      fill: "#F5F5F5"
    },
    width: 26.714,
    height: 24.832
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 357.981,
    y: 82.672,
    style: {
      fill: "#E0E0E0"
    },
    width: 52.07,
    height: 57.177
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.906,
    y: 82.672,
    style: {
      fill: "#F5F5F5"
    },
    width: 53.785,
    height: 57.177
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.716,
    y: 88.874,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 500.0589 -277.5375)",
    style: {
      fill: "#FFFFFF"
    },
    width: 48.165,
    height: 44.773
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F5F5F5"
    },
    cx: 388.798,
    cy: 111.261,
    r: 13.968
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 140.909,
    y: 112.197,
    style: {
      fill: "#E0E0E0"
    },
    width: 41.58,
    height: 45.658
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.044,
    y: 112.197,
    style: {
      fill: "#F5F5F5"
    },
    width: 42.95,
    height: 45.658
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.288,
    y: 117.149,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 300.5446 -30.4925)",
    style: {
      fill: "#FFFFFF"
    },
    width: 38.462,
    height: 35.753
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "165.519,125.303 155.741,142.24 175.297,142.24  "
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Background_simple",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M134.459,237.745c58.535,60.355,135.467,102.202,206.777,34.624 c36.76-34.836,85.341-128.934,37.404-171.992c-66.066-59.342-103.98,37.755-153.374,50.911 c-33.858,9.018-62.321-42.96-102.854-8.254C90.369,170.469,110.124,212.654,134.459,237.745z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F5F5F5"
    },
    cx: 250,
    cy: 416.238,
    rx: 193.889,
    ry: 11.323
  })), /*#__PURE__*/React.createElement("g", {
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E58A7B"
    },
    d: "M349.246,163.432l-9.919-4.022c0,0-13.09,23.873-16.839,25.078 c-5.102,1.64-15.653,6.199-21.923,7.053c-0.845,0.988-2.239,4.104-2.106,5.24c8.412,2.805,26.892-0.92,30.848-3.857 C338.325,186.225,349.246,163.432,349.246,163.432z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M352.3,158.015c1.845,6.839-8.174,20.576-8.174,20.576l-13.162-7.383 c0,0,2.454-5.647,5.458-11.398C341.273,150.523,350.193,150.21,352.3,158.015z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M352.3,158.015c1.845,6.839-8.174,20.576-8.174,20.576l-13.162-7.383c0,0,2.454-5.647,5.458-11.398 C341.273,150.523,350.193,150.21,352.3,158.015z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M336.212,174.148l5.169,2.898l0.904-15.866C339.285,163.492,337.157,170.449,336.212,174.148z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M343.662,152.863c0,0-10.219,22.736-4.261,65.077c12.134,0,34.366,0,40.27,0 c0.64-6.182-1.476-36.338,6.194-65.465c0,0-6.822-1.385-13.381-1.702c-5.131-0.248-12.571-0.412-17.119,0.001 C349.369,151.318,343.662,152.863,343.662,152.863z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M343.662,152.863c0,0-10.219,22.736-4.261,65.077c12.134,0,34.366,0,40.27,0 c0.64-6.182-1.476-36.338,6.194-65.465c0,0-6.822-1.385-13.381-1.702c-5.131-0.248-12.571-0.412-17.119,0.001 C349.369,151.318,343.662,152.863,343.662,152.863z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8ECF1"
    },
    d: "M334.323,417.142c-0.063,1.074,15.205,1.944,34.102,1.944s34.267-0.87,34.33-1.944 c0.063-1.074-15.205-1.944-34.102-1.944C349.756,415.197,334.386,416.068,334.323,417.142z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.82,
    y: 390.959,
    transform: "matrix(0.9331 -0.3595 0.3595 0.9331 -119.4566 156.7512)",
    style: {
      fill: "#E58A7B"
    },
    width: 7.68,
    height: 17.093
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E58A7B"
    },
    points: "393.051,409.454 385.522,409.454 382.76,392.018 390.289,392.018  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M385.038,408.582l8.459,0c0.308,0,0.562,0.214,0.611,0.514l1.095,6.692 c0.114,0.694-0.47,1.351-1.181,1.339c-2.95-0.051-4.375-0.224-8.094-0.224c-2.288,0-7.017,0.238-10.178,0.238 c-3.091,0-3.39-3.125-2.079-3.408c5.875-1.269,8.163-3.019,10.118-4.688C384.141,408.744,384.588,408.582,385.038,408.582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M359.972,405.946l8.021-2.332c0.3-0.087,0.609,0.042,0.742,0.311l2.972,5.996 c0.308,0.621-0.056,1.401-0.752,1.591c-2.905,0.793-4.858,1.289-8.495,2.346c-2.513,0.73-5.069,1.92-7.552,2.712 c-1.719,0.548-5.756,0.57-7.847,0.57c-3.091,0-3.78-3.259-2.455-3.408c3.353-0.376,3.803-0.202,5.654-1.13 c3.06-1.535,5.427-2.806,8.076-5.581C358.798,406.539,359.339,406.13,359.972,405.946z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E58A7B"
    },
    d: "M301.833,191.469l-8.285-3.486l-3.411,9.178c0,0,4.781,0.867,10.241,0L301.833,191.469z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E58A7B"
    },
    points: "287.391,187.758 287.172,193.865 290.137,197.161 293.548,187.983  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 356.33,
    y: 391.241,
    transform: "matrix(0.9329 -0.3601 0.3601 0.9329 -118.3055 156.2321)",
    style: {
      fill: "#CF6F64"
    },
    width: 7.683,
    height: 8.811
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CF6F64"
    },
    points: "390.291,392.023 382.759,392.023 384.187,401.01 391.719,401.01  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M338.123,206.487c0.144,1.809,0.319,3.658,0.534,5.559l29.945-9.721 c4.676-1.398,8.745-4.337,11.52-8.354c0.113-2.672,0.267-5.477,0.493-8.406c0.103-1.428,0.226-2.888,0.36-4.367 c0.144-1.541,0.308-3.114,0.493-4.696L338.123,206.487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M347.9,173.688l-1.02-0.121c0.594-4.99,4.319-8.934,8.254-8.84l-0.03,1.028 C351.707,165.656,348.434,169.213,347.9,173.688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M353.228,182.922c-0.056,0-0.112-0.001-0.169-0.002l0.03-1.028c3.439,0.126,6.67-3.459,7.204-7.934 l1.02,0.122C360.727,178.999,357.12,182.922,353.228,182.922z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E58A7B"
    },
    d: "M371.918,131.497c-1.403,5.508-3.072,15.6,0.566,19.275c0,0-2.541,5.587-12.776,5.587 c-9.353,0-4.343-5.587-4.343-5.587c6.228-1.467,6.337-6.024,5.518-10.304L371.918,131.497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CF6F64"
    },
    d: "M367.419,135.158l-6.531,5.307c0.197,1.013,0.337,2.04,0.35,3.038 c1.909,1.901,5.741-2.915,6.134-5.372C367.567,136.907,367.585,135.729,367.419,135.158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CF6F64"
    },
    d: "M349.664,131.429c0.957,1.714,2.646,2.781,4.242,3.136c2.401,0.535,3.608-1.674,2.946-3.897 c-0.596-2.001-2.563-4.69-4.976-4.229C349.499,126.894,348.569,129.469,349.664,131.429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M353.626,113.8c-3.74,1.714-5.058,16.571-0.356,18.768 C357.972,134.764,360.71,110.555,353.626,113.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E58A7B"
    },
    d: "M373.059,123.208c-0.895,7.458-1.042,11.847-5.033,15.675c-6.004,5.758-15.01,2.343-16.353-5.102 c-1.209-6.701,0.458-17.772,7.933-20.74C366.97,110.117,373.954,115.75,373.059,123.208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M360.774,117.665c5.532-1.415,9.604-2.379,8.151,2.239c-1.936,6.152-4.258,12.112-1.143,12.39 c1.894,0.169,10.295-3.396,9.228-7c-0.929-3.14,2.976-3.987,3.696-5.588c2.593-5.766-4.816-5.017-3.498-8.506 c1.284-3.397-5.969-9.138-9.988-6.333c-6.505,4.541-17.685,4.476-11.807-2.972c4.209-5.334-3.301-4.239-3.301-4.239 s4.536,2.691-3.099,6.851C340.919,108.915,348.328,120.849,360.774,117.665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E58A7B"
    },
    d: "M375.946,131.429c-1.159,1.714-2.972,2.781-4.61,3.136c-2.464,0.535-3.411-1.674-2.489-3.897 c0.831-2.001,3.113-4.69,5.472-4.229C376.642,126.894,377.27,129.469,375.946,131.429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M339.401,217.94c0,0-6.759,60.497-7.287,83.457c-0.548,23.882,22.908,98.394,22.908,98.394 l12.011-5.044c0,0-13.985-68.073-12.042-91.528c2.118-25.569,10.881-85.28,10.881-85.28H339.401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M356.199,234.551c-5.385,11.18-1.757,33.284,1.161,46.387c1.11-9.249,2.425-19.288,3.679-28.578 C360.916,238.076,359.806,227.05,356.199,234.551z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M366.49,390.826c0.056-0.023,1.424,3.828,1.424,3.828l-13.844,5.813l-2.181-4.055L366.49,390.826z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M353.686,217.94c0,0,5.171,57.538,8.598,79.094c3.753,23.605,18.495,102.236,18.495,102.236h13.79 c0,0-8.263-76.725-9.824-100.096c-1.694-25.366-5.075-81.234-5.075-81.234H353.686z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M394.78,395.677c0.059,0,0.461,3.854,0.461,3.854h-15.157l-1.082-4.424L394.78,395.677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M389.497,391.122c-0.065,0-0.12-0.049-0.127-0.114c-0.075-0.698-7.526-69.967-8.928-90.965 c-1.521-22.787-4.58-73.312-4.611-73.82c-0.004-0.071,0.05-0.132,0.12-0.136c0.003,0,0.006,0,0.008,0 c0.067,0,0.125,0.053,0.129,0.121c0.03,0.507,3.089,51.032,4.611,73.817c1.401,20.994,8.851,90.258,8.926,90.955 c0.008,0.071-0.043,0.134-0.113,0.141C389.506,391.122,389.501,391.122,389.497,391.122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M361.624,125.293c-0.036,0.607-0.386,1.1-0.783,1.1c-0.397,0-0.69-0.492-0.654-1.1 c0.035-0.607,0.386-1.1,0.783-1.1C361.367,124.193,361.66,124.686,361.624,125.293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M354.76,125.293c-0.036,0.607-0.386,1.1-0.783,1.1s-0.69-0.492-0.654-1.1 c0.036-0.607,0.386-1.1,0.783-1.1C354.503,124.193,354.796,124.686,354.76,125.293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DF5753"
    },
    d: "M356.924,125.595c0,0-1.586,3.504-3.206,5.194c1.016,1.003,2.869,0.544,2.869,0.544 L356.924,125.595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M357.099,133.881c-0.098,0-0.174-0.08-0.168-0.178c0.006-0.098,0.091-0.178,0.189-0.178 c2.666,0,4.019-1.862,4.033-1.881c0.06-0.082,0.172-0.106,0.25-0.052c0.079,0.054,0.096,0.164,0.037,0.247 C361.38,131.921,359.956,133.881,357.099,133.881z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M362.845,123.446c-0.103,0.04-0.219,0.034-0.315-0.027c-1.312-0.826-2.535-0.272-2.547-0.265 c-0.168,0.086-0.391,0.011-0.466-0.167c-0.075-0.178,0.013-0.391,0.195-0.476c0.065-0.031,1.596-0.726,3.224,0.299 c0.163,0.103,0.203,0.322,0.091,0.49C362.981,123.368,362.916,123.418,362.845,123.446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M352.106,121.451c-0.049-0.014-0.097-0.039-0.136-0.077c-0.14-0.13-0.14-0.355,0-0.503 c1.396-1.475,3.014-1.25,3.082-1.24c0.19,0.021,0.317,0.21,0.276,0.405c-0.041,0.194-0.229,0.328-0.421,0.3l0,0 c-0.054-0.008-1.317-0.169-2.432,1.008C352.376,121.45,352.231,121.487,352.106,121.451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E58A7B"
    },
    d: "M389.73,162.317l-10.403-2.769c0,0-10.2,25.108-13.803,26.747 c-4.903,2.231-17.317,9.947-22.593,13.668c-0.293,1.244-0.063,4.56,0.601,5.463c8.971-1.63,26.23-8.265,29.829-11.638 C381.567,186.099,389.73,162.317,389.73,162.317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M382.471,409.897c-0.573,0-1.103-0.098-1.427-0.383c-0.257-0.227-0.362-0.545-0.313-0.943 c0.036-0.297,0.201-0.438,0.335-0.504c0.849-0.426,3.198,1.064,3.463,1.236c0.058,0.039,0.086,0.11,0.071,0.181 c-0.016,0.07-0.072,0.127-0.143,0.143C383.926,409.753,383.167,409.897,382.471,409.897z M381.444,408.339 c-0.093,0-0.172,0.014-0.234,0.045c-0.049,0.025-0.108,0.071-0.124,0.209c-0.035,0.284,0.031,0.496,0.204,0.648 c0.391,0.347,1.371,0.393,2.665,0.135C383.133,408.884,382.021,408.339,381.444,408.339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M384.415,409.632c-0.029,0-0.058-0.007-0.084-0.021c-0.755-0.424-2.164-2.073-1.955-2.913 c0.037-0.152,0.165-0.415,0.595-0.467c0.281-0.035,0.53,0.043,0.746,0.228c0.833,0.715,0.885,2.888,0.887,2.98 c0.002,0.065-0.033,0.128-0.09,0.163C384.483,409.622,384.449,409.632,384.415,409.632z M383.075,406.58 c-0.026,0-0.053,0.003-0.081,0.006c-0.233,0.028-0.26,0.135-0.271,0.18c-0.124,0.496,0.763,1.743,1.503,2.331 c-0.051-0.635-0.217-1.902-0.75-2.36C383.353,406.631,383.222,406.58,383.075,406.58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M355.917,408.653c-0.736,0.178-1.438,0.231-1.886-0.012c-0.285-0.154-0.449-0.412-0.487-0.763 c-0.023-0.21,0.048-0.393,0.203-0.53c0.806-0.717,4.068,0.054,4.438,0.144c0.072,0.018,0.123,0.08,0.126,0.156 c0.003,0.076-0.041,0.147-0.112,0.18C357.594,408.102,356.734,408.455,355.917,408.653z M354.291,407.465 c-0.137,0.033-0.245,0.08-0.316,0.143c-0.063,0.056-0.086,0.12-0.076,0.212c0.026,0.238,0.13,0.404,0.316,0.506 c0.531,0.289,1.764,0.06,3.351-0.604C356.451,407.488,354.993,407.294,354.291,407.465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M358.166,407.838c-0.025,0.006-0.05,0.006-0.075,0.003c-0.969-0.18-3.039-1.33-3.058-2.191 c-0.005-0.201,0.09-0.477,0.564-0.641c0.344-0.129,0.698-0.103,1.03,0.06c1.087,0.536,1.655,2.456,1.679,2.537 c0.017,0.06,0.001,0.126-0.043,0.175C358.236,407.81,358.202,407.829,358.166,407.838z M355.801,405.312 c-0.034,0.008-0.069,0.02-0.105,0.031c-0.31,0.109-0.307,0.236-0.307,0.278c0.012,0.516,1.449,1.466,2.464,1.786 c-0.202-0.552-0.688-1.666-1.4-2.017C356.239,405.284,356.024,405.258,355.801,405.312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E58A7B"
    },
    d: "M343.778,199.372l-10.428,4.8l-1.21,2.942l3.854,2.593c0,0,7.192-0.783,9.241-5.404 L343.778,199.372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M344.222,205.596c-0.652-3.874-1.926-5.641-1.938-5.658l1.644-1.233 c0.064,0.085,1.575,2.125,2.321,6.55L344.222,205.596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M345.998,200.791c0.338,0.837-0.205,1.845-1.214,2.253c-1.009,0.408-2.1,0.06-2.438-0.777 c-0.338-0.837,0.205-1.845,1.214-2.253C344.568,199.607,345.66,199.954,345.998,200.791z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E58A7B"
    },
    points: "326.304,208.048 327.689,209.451 337.046,205.449 333.35,204.173  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M366.49,390.826c0.056-0.023,1.424,3.828,1.424,3.828l-13.844,5.813l-2.181-4.055L366.49,390.826z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M394.78,395.677c0.059,0,0.461,3.854,0.461,3.854h-15.157l-1.082-4.424L394.78,395.677z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M392.441,159.439c2.751,8.867-7.96,20.98-7.96,20.98l-14.848-6.06c0,0,2.092-6.442,6.073-15.073 C380.232,149.477,389.664,150.49,392.441,159.439z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M392.441,159.439c2.751,8.867-7.96,20.98-7.96,20.98l-14.848-6.06c0,0,2.092-6.442,6.073-15.073 C380.232,149.477,389.664,150.49,392.441,159.439z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Screen"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 238.487,
    y: 70.57,
    style: {
      fill: "#407BFF"
    },
    width: 6.387,
    height: 1.028
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.139,
    y: 119.423,
    transform: "matrix(0.045 -0.999 0.999 0.045 193.165 441.9351)",
    style: {
      fill: "#407BFF"
    },
    width: 17.176,
    height: 1.027
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "325.613,75.194 207.614,75.194 196.629,320.913 314.628,320.913  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.56,
      fill: "#FAFAFA"
    },
    points: "322.09,78.566 204.091,78.566 193.107,324.285 311.106,324.285  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.07,
      fill: "#407BFF"
    },
    points: "318.567,81.938 200.569,81.938 189.584,327.657 307.583,327.657  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "305.136,189.106 204.419,189.106 203.578,207.912 304.296,207.912  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "259.815,175.39 205.032,175.39 204.656,183.804 259.438,183.804  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "302.868,239.849 202.15,239.849 201.309,258.655 302.027,258.655  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.47,
      fill: "#407BFF"
    },
    points: "284.398,284.036 216.669,284.036 215.662,306.575 283.39,306.575  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M279.868,310.066h-67.728c-0.032,0-0.063-0.014-0.086-0.037c-0.022-0.023-0.034-0.055-0.032-0.087 l1.008-22.539c0.002-0.064,0.055-0.114,0.118-0.114h67.728c0.032,0,0.063,0.014,0.086,0.037c0.022,0.023,0.034,0.055,0.032,0.087 l-1.008,22.539C279.984,310.016,279.931,310.066,279.868,310.066z M212.264,309.828h67.49l0.996-22.301h-67.49L212.264,309.828z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "247.978,226.134 202.763,226.134 202.387,234.548 247.601,234.548  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M283.106,128.379c-0.252,5.631-2.293,10.831-5.565,15.055c-4.941,6.402-12.68,10.564-21.199,10.564 c-8.519,0-15.876-4.162-20.244-10.564c-2.894-4.224-4.47-9.423-4.218-15.055c0.633-14.15,12.613-25.618,26.753-25.618 C272.783,102.76,283.738,114.229,283.106,128.379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M285.515,108.123c-0.067,1.496-0.609,2.878-1.479,4c-1.313,1.701-3.369,2.807-5.633,2.807 s-4.218-1.106-5.379-2.807c-0.769-1.122-1.188-2.504-1.121-4c0.168-3.76,3.352-6.807,7.109-6.807 C282.772,101.316,285.683,104.363,285.515,108.123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M215.265,198.509c-0.074,1.664-1.484,3.013-3.148,3.013c-1.664,0-2.953-1.349-2.879-3.013 c0.074-1.664,1.484-3.013,3.148-3.013C214.051,195.495,215.34,196.845,215.265,198.509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M228.752,198.509c-0.074,1.664-1.484,3.013-3.148,3.013c-1.664,0-2.953-1.349-2.879-3.013 c0.074-1.664,1.484-3.013,3.148-3.013S228.827,196.845,228.752,198.509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M242.24,198.509c-0.074,1.664-1.484,3.013-3.148,3.013c-1.664,0-2.953-1.349-2.879-3.013 c0.074-1.664,1.484-3.013,3.148-3.013C241.025,195.495,242.314,196.845,242.24,198.509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M212.997,249.252c-0.074,1.664-1.484,3.013-3.148,3.013c-1.664,0-2.953-1.349-2.879-3.013 c0.074-1.664,1.484-3.014,3.148-3.014C211.782,246.239,213.071,247.588,212.997,249.252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M226.484,249.252c-0.074,1.664-1.484,3.013-3.148,3.013c-1.664,0-2.953-1.349-2.879-3.013 c0.074-1.664,1.484-3.014,3.148-3.014C225.27,246.239,226.558,247.588,226.484,249.252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M239.971,249.252c-0.074,1.664-1.484,3.013-3.148,3.013c-1.664,0-2.953-1.349-2.879-3.013 c0.074-1.664,1.484-3.014,3.148-3.014S240.046,247.588,239.971,249.252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M253.459,249.252c-0.074,1.664-1.484,3.013-3.148,3.013c-1.664,0-2.953-1.349-2.879-3.013 c0.074-1.664,1.484-3.014,3.148-3.014C252.244,246.239,253.533,247.588,253.459,249.252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M266.946,249.252c-0.074,1.664-1.484,3.013-3.148,3.013c-1.664,0-2.953-1.349-2.879-3.013 c0.074-1.664,1.484-3.014,3.148-3.014C265.731,246.239,267.02,247.588,266.946,249.252z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M268.236,119.816c-0.256,5.722-5.102,10.361-10.825,10.361c-5.722,0-10.154-4.639-9.898-10.361 c0.256-5.723,5.102-10.361,10.825-10.361C264.06,109.455,268.492,114.094,268.236,119.816z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M277.541,143.433c-4.941,6.402-12.68,10.564-21.199,10.564c-8.519,0-15.876-4.162-20.244-10.564 c4.861-4.84,12.555-7.984,21.074-7.984C265.7,135.449,273.113,138.593,277.541,143.433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF"
    },
    d: "M268.236,119.816c-0.256,5.722-5.102,10.361-10.825,10.361 c-5.722,0-10.154-4.639-9.898-10.361c0.256-5.723,5.102-10.361,10.825-10.361C264.06,109.455,268.492,114.094,268.236,119.816z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF"
    },
    d: "M277.541,143.433c-4.941,6.402-12.68,10.564-21.199,10.564 c-8.519,0-15.876-4.162-20.244-10.564c4.861-4.84,12.555-7.984,21.074-7.984C265.7,135.449,273.113,138.593,277.541,143.433z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E58A7B"
    },
    d: "M130.407,212.443c-0.947,2.077-1.944,4.362-2.819,6.591c-0.882,2.25-1.762,4.502-2.529,6.786 c-1.49,4.568-2.887,9.178-3.575,13.801l-0.228,1.472c-0.018,0.177-0.005,0.429,0.073,0.745c0.146,0.635,0.542,1.485,1.099,2.319 c1.126,1.687,2.722,3.395,4.443,4.981c1.717,1.611,3.582,3.152,5.52,4.615c1.919,1.476,3.943,2.921,5.923,4.275l-1.864,3.509 c-4.758-2.08-9.189-4.567-13.481-7.688c-2.11-1.608-4.194-3.339-6.04-5.679c-0.91-1.18-1.805-2.513-2.391-4.273 c-0.284-0.878-0.482-1.871-0.483-2.945c0.007-0.247,0.02-0.594,0.037-0.76l0.049-0.497l0.1-0.994 c0.544-5.301,1.718-10.396,3.265-15.338c0.78-2.468,1.612-4.911,2.562-7.308c0.97-2.413,1.927-4.729,3.14-7.158L130.407,212.443z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E58A7B"
    },
    d: "M136.914,257.432l7.066-3.585l-1.825,7.766c0,0-4.852,1.355-7.109-0.999L136.914,257.432z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E58A7B"
    },
    points: "150.451,255.122 148.571,261.542 142.154,261.614 143.98,253.847  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DF5753"
    },
    d: "M160.432,175.001c0,0,0.613,2.254,1.585,3.953c-0.835,0.78-1.585,0.509-1.585,0.509V175.001z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#263238"
    },
    cx: 160.223,
    cy: 173.914,
    rx: 0.749,
    ry: 1.146
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M160.04,172.803l1.52-0.438C161.56,172.365,160.78,173.553,160.04,172.803z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E58A7B"
    },
    d: "M140.897,182.336c0.913,4.655,1.824,13.185-1.434,16.291c0,0,1.273,4.722,9.923,4.722 c9.512,0,4.546-4.722,4.546-4.722c-5.191-1.24-5.057-5.091-4.153-8.708L140.897,182.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E58A7B"
    },
    d: "M138.373,171.742c0.477,7.772,0.513,11.071,4.439,15.06c5.904,6,15.345,3.714,17.2-4.043 c1.669-6.983,0.608-18.519-6.999-21.612C145.517,158.1,137.895,163.97,138.373,171.742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M139.139,162.948c-3.897,1.421-9.096,0.364-7.056,12.393c2.16,12.737-1.165,16.927-1.165,16.927 s14.792,3.151,29.892-0.188c0,0-4.61-8.062-3.316-13.945c1.65-7.503,0.342-10.276,0.342-10.276S144.619,160.95,139.139,162.948z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E58A7B"
    },
    d: "M155.64,175.792c-0.016,1.54,0.524,3.091,1.224,4.168c1.053,1.621,2.303,0.961,2.616-0.722 c0.282-1.514,0.073-4.182-1.276-5.217C156.876,173.003,155.659,174.032,155.64,175.792z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M135.754,164.309c-1.125-3.145,4.219-7.982,15.517-5.97c11.298,2.012,11.794,11.408,11.794,11.408 l-2.286-2.713l0.103,2.857l-11.611,2.231L135.754,164.309z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M136.712,199.156L136.712,199.156c-0.156-0.961,0.49-1.866,1.45-2.024 c3.518-0.581,11.514-1.757,15.539-1.2c2.99,0.414,3.781,2.16,3.907,3.588c0.094,1.059-0.782,1.952-1.844,1.904l-17.389-0.786 C137.54,200.6,136.845,199.982,136.712,199.156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6
    },
    d: "M136.712,199.156L136.712,199.156c-0.156-0.961,0.49-1.866,1.45-2.024 c3.518-0.581,11.514-1.757,15.539-1.2c2.99,0.414,3.781,2.16,3.907,3.588c0.094,1.059-0.782,1.952-1.844,1.904l-17.389-0.786 C137.54,200.6,136.845,199.982,136.712,199.156z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E58A7B"
    },
    points: "146.76,373.862 153.205,378.336 163.997,363.71 157.552,359.236  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E58A7B"
    },
    points: "131.715,373.566 138.533,377.449 148.084,361.98 141.267,358.098  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CF6F64"
    },
    points: "163.992,363.713 158.431,371.253 151.984,366.777 157.545,359.237  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CF6F64"
    },
    points: "141.263,358.101 148.083,361.985 143.156,369.957 136.336,366.073  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M152.198,247.988c0,0,25.18,31.735,20.456,62.082c-3.816,24.512-25.913,57.703-25.913,57.703 l-10.39-5.164c0,0,11.289-22.058,18.702-45.441c3.109-9.806,1.784-20.609-4.028-29.097c-12.755-18.63-33.19-7.545-19.444-40.082 H152.198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6
    },
    d: "M152.198,247.988c0,0,25.18,31.735,20.456,62.082c-3.816,24.512-25.913,57.703-25.913,57.703 l-10.39-5.164c0,0,11.289-22.058,18.702-45.441c3.109-9.806,1.784-20.609-4.028-29.097c-12.755-18.63-33.19-7.545-19.444-40.082 H152.198z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M164.549,268.38l-3.658-3.638c0,0.288,7.091,44.054,9.084,56.354 c1.202-3.771,2.127-7.491,2.682-11.026C174.969,295.211,170.108,280.013,164.549,268.38z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M163.444,247.988c0,0,30.319,39.88,31.172,63.795c0.715,20.038-33.025,58.745-33.025,58.745 l-9.795-6.337c0,0,19.729-27.517,24.696-50.011c-1.894-22.265-42.542-66.193-42.542-66.193H163.444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6
    },
    d: "M163.444,247.988c0,0,30.319,39.88,31.172,63.795c0.715,20.038-33.025,58.745-33.025,58.745 l-9.795-6.337c0,0,19.729-27.517,24.696-50.011c-1.894-22.265-42.542-66.193-42.542-66.193H163.444z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M125.933,200.41c-3.247,0.766-6.35,12.553-6.35,12.553l12.663,8.453c0,0,4.22-9.316,2.747-13.397 C133.458,203.769,130.033,199.443,125.933,200.41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M128.411,207.994l-0.885,10.269l4.714,3.155c0,0,2.209-4.881,2.867-9.135L128.411,207.994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M167.193,200.637c0,0,3.737,1.316-3.749,47.351c-12.644,0-25.711,0-31.863,0 c0.535-12.968,0.55-20.965-5.648-47.578c0,0,6.676-1.452,13.53-1.783c5.362-0.258,9.755-0.43,14.469,0.001 C160.146,199.195,167.193,200.637,167.193,200.637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E58A7B"
    },
    d: "M170.429,207.947c0.722,1.995,1.486,4.153,2.281,6.225c0.763,2.103,1.555,4.202,2.372,6.292 l2.452,6.281l0.62,1.57l0.311,0.785l0.156,0.392c0.027,0.07,0.022,0.064,0.012,0.057c-0.043-0.019-0.08-0.217-0.7-0.624 c-0.304-0.189-0.814-0.371-1.306-0.381c-0.495-0.018-0.887,0.103-1.112,0.201c-0.451,0.215-0.458,0.308-0.448,0.293 c0.029-0.015,0.122-0.104,0.224-0.227c0.437-0.525,0.965-1.43,1.428-2.33c0.473-0.917,0.92-1.897,1.365-2.891 c0.885-1.993,1.69-4.073,2.509-6.156c0.81-2.089,1.573-4.209,2.329-6.335l2.276-6.382l3.853,0.971 c-0.762,4.565-1.748,9.036-2.923,13.523c-0.574,2.248-1.238,4.477-1.997,6.727c-0.378,1.127-0.801,2.251-1.287,3.397 c-0.505,1.155-1.006,2.294-1.9,3.617c-0.235,0.335-0.501,0.689-0.872,1.079c-0.392,0.384-0.845,0.848-1.822,1.287 c-0.486,0.209-1.162,0.394-1.942,0.363c-0.777-0.022-1.565-0.298-2.11-0.636c-1.108-0.708-1.491-1.382-1.819-1.888 c-0.152-0.254-0.282-0.516-0.372-0.705l-0.19-0.388l-0.38-0.776l-0.756-1.553c-0.988-2.081-1.956-4.173-2.873-6.288 c-0.908-2.12-1.793-4.252-2.651-6.4c-0.821-2.181-1.633-4.294-2.356-6.614L170.429,207.947z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M167.193,200.637c3.83,0.912,8.133,12.228,8.133,12.228l-11.382,9.699 c0,0-7.377-12.339-5.884-16.413C159.614,201.908,162.19,199.445,167.193,200.637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E58A7B"
    },
    d: "M186.976,201.189l3.995-3.341l2.779,4.329l-2.047,3.615c0,0-3.26,2.984-6.146,1.466l0,0 C184.625,205.145,185.204,202.671,186.976,201.189z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E58A7B"
    },
    points: "198.222,197.858 197.923,198.947 191.594,200.01 190.97,197.848  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "162.402,371.053 150.983,363.667 153.028,360.111 165.861,368  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M142.983,376.926c-0.908,0-2.103-0.576-2.827-0.978c-0.065-0.036-0.102-0.107-0.094-0.182 c0.007-0.073,0.058-0.135,0.128-0.159c0.308-0.097,3.017-0.927,3.784-0.283c0.121,0.102,0.256,0.29,0.213,0.603 c-0.056,0.415-0.246,0.708-0.564,0.866C143.439,376.885,143.221,376.926,142.983,376.926z M140.734,375.835 c1.242,0.632,2.242,0.865,2.723,0.626c0.205-0.102,0.323-0.293,0.363-0.584c0.021-0.157-0.034-0.226-0.085-0.268 C143.332,375.27,141.83,375.534,140.734,375.835z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M140.247,375.97c-0.05,0-0.098-0.02-0.133-0.056c-0.046-0.048-0.063-0.116-0.045-0.18 c0.026-0.092,0.65-2.264,1.677-2.759c0.274-0.131,0.552-0.138,0.824-0.025c0.432,0.182,0.475,0.498,0.46,0.669 c-0.07,0.899-1.903,2.141-2.739,2.345C140.277,375.968,140.262,375.97,140.247,375.97z M142.185,373.243 c-0.092,0-0.185,0.023-0.279,0.068c-0.612,0.295-1.126,1.467-1.372,2.18c0.88-0.37,2.081-1.352,2.124-1.9 c0.007-0.089-0.013-0.205-0.234-0.297C142.345,373.26,142.265,373.243,142.185,373.243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M157.268,381.247c-1.126,0-2.696-1.447-3.555-2.336c-0.055-0.057-0.068-0.142-0.033-0.213 c0.036-0.07,0.126-0.11,0.19-0.101c0.396,0.051,3.874,0.521,4.365,1.503c0.094,0.19,0.086,0.392-0.023,0.585 c-0.184,0.324-0.451,0.51-0.792,0.553C157.371,381.244,157.32,381.247,157.268,381.247z M154.371,379.045 c1.264,1.228,2.368,1.908,3.003,1.823c0.222-0.028,0.39-0.147,0.515-0.367c0.048-0.084,0.052-0.158,0.013-0.235 C157.635,379.732,155.778,379.271,154.371,379.045z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M154.481,379.014c-0.257,0-0.487-0.016-0.668-0.05c-0.064-0.012-0.118-0.057-0.141-0.118 c-0.022-0.062-0.011-0.132,0.031-0.183c0.057-0.069,1.41-1.7,2.688-1.812c0.4-0.031,0.739,0.075,1.029,0.323 c0.393,0.337,0.366,0.637,0.274,0.829C157.377,378.669,155.649,379.014,154.481,379.014z M154.223,378.639 c1.117,0.062,2.903-0.309,3.136-0.796c0.02-0.041,0.079-0.165-0.18-0.386c-0.216-0.185-0.466-0.262-0.755-0.236 C155.585,377.295,154.648,378.185,154.223,378.639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M140.521,374.918l-8.482-2.398c-0.309-0.087-0.62,0.056-0.748,0.345l-2.863,6.437 c-0.297,0.668,0.115,1.496,0.831,1.685c2.971,0.785,4.445,1.014,8.175,2.069c2.295,0.649,5.58,1.835,8.749,2.73 c3.099,0.876,4.223-2.19,2.984-2.847c-5.557-2.945-5.995-4.964-7.515-7.201C141.378,375.335,140.973,375.046,140.521,374.918z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M153.944,377.743l-7.24-5.027c-0.264-0.183-0.604-0.148-0.82,0.083l-4.802,5.156 c-0.498,0.535-0.377,1.452,0.238,1.863c2.554,1.709,3.874,2.405,7.058,4.616c1.959,1.36,5.869,4.376,8.574,6.254 c2.646,1.837,4.706-0.697,3.748-1.721c-4.296-4.592-5.244-7.47-5.953-10.081C154.618,378.416,154.329,378.01,153.944,377.743z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "148.075,368.436 135.018,361.947 136.37,358.414 150.306,365.245  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M131.104,246.118l-1.105,2.852c-0.112,0.221,0.15,0.447,0.519,0.447h33.083 c0.287,0,0.525-0.141,0.543-0.321l0.287-2.852c0.02-0.198-0.229-0.365-0.543-0.365h-32.266 C131.386,245.879,131.176,245.976,131.104,246.118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    d: "M131.104,246.118l-1.105,2.852c-0.112,0.221,0.15,0.447,0.519,0.447h33.083 c0.287,0,0.525-0.141,0.543-0.321l0.287-2.852c0.02-0.198-0.229-0.365-0.543-0.365h-32.266 C131.386,245.879,131.176,245.976,131.104,246.118z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M136.307,249.726h-0.864c-0.172,0-0.303-0.089-0.291-0.197l0.405-3.705 c0.012-0.108,0.162-0.197,0.335-0.197h0.864c0.172,0,0.303,0.089,0.291,0.197l-0.405,3.705 C136.63,249.638,136.479,249.726,136.307,249.726z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M156.714,249.726h-0.864c-0.172,0-0.303-0.089-0.291-0.197l0.405-3.705 c0.012-0.108,0.162-0.197,0.335-0.197h0.864c0.172,0,0.303,0.089,0.291,0.197l-0.405,3.705 C157.037,249.638,156.886,249.726,156.714,249.726z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F5F5F5"
    },
    cx: 135.546,
    cy: 417.143,
    rx: 26.791,
    ry: 1.944
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M151.873,414.4c-4.74-1.376-9.957-3.149-13.185-5.034c-0.09-0.052-0.185-0.09-0.276-0.138 v-21.429h9.534c1.577,0,2.855-1.278,2.855-2.855c0-1.576-1.278-2.854-2.855-2.854h-9.534v-97.823h-5.709v97.823h-9.534 c-1.576,0-2.854,1.278-2.854,2.854c0,1.577,1.278,2.855,2.854,2.855h9.534v21.428c-0.091,0.048-0.186,0.085-0.276,0.138 c-3.228,1.885-8.445,3.658-13.185,5.034c-1.555,0.451-1.227,2.742,0.392,2.742h15.923h15.923 C153.1,417.142,153.428,414.851,151.873,414.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M153.34,295.247h-35.565c-2.849,0-5.18-2.331-5.18-5.18v-10.573c0-2.849,2.331-5.18,5.18-5.18 h35.565c2.849,0,5.18,2.331,5.18,5.18v10.573C158.52,292.916,156.189,295.247,153.34,295.247z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M117.448,295.247v1.82c0,1.5,1.633,2.728,3.628,2.728h28.963c1.995,0,3.628-1.227,3.628-2.728 v-1.82H117.448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M117.448,295.247v1.82c0,1.5,1.633,2.728,3.628,2.728h28.963 c1.995,0,3.628-1.227,3.628-2.728v-1.82H117.448z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignup);
export default __webpack_public_path__ + "static/media/signup.7984290ecc4065ca224a36977eb62c26.svg";
export { ForwardRef as ReactComponent };